import styled from 'styled-components';

const Image = styled.img`
  width: auto;
  height: 100%;
  `;

export default Image;
